function selectExperience(scope, element, attrs, ctrl, $compile, $timeout, $location)
{
	
	var selectedExperience = $(element).val();

	$location.search('submenu_key', selectedExperience);

	scope.$apply();
}

function changePageMenu(scope, element, attrs, ctrl, $compile, $timeout, $location)
{
	var page = attrs.customFunctionPage;
	var submenu = typeof(scope.appState.submenu_key) != 'undefined' ? scope.appState.submenu_key : null
	
	if(typeof(scope.navigation[page]) != 'undefined')
	{
		newSubmenu = '';
		if(typeof(scope.navigation[page].submenu) != 'undefined')
		{
			$.each(scope.navigation[page].submenu, function(key, value)
			{
				if(submenu !== null && submenu == value.key)
				{
					newSubmenu = value.key;
					return false;
				}
			});
			
			//if not found, get the first item
			if(newSubmenu == '')
			{
				$.each(scope.navigation[page].submenu, function(key, value)
				{
					newSubmenu = value.key;
					return false;
				});
			}
		}
		
		var newLocation = {'submenu_key' : newSubmenu, 'page' : page};
		$location.path('/' + page).search(newLocation);
		scope.$apply();
	}	
}

function showFiltersSelectedAsText(scope, element, attrs, ctrl, $compile, $timeout, $location)
{
	var params = JSON.parse(attrs.customFunctionParams);
	var filters = params.filters;
	var submenu_key = params.submenu_key;
	
	if(submenu_key != scope.submenuView)
		return false;
	
	scope.filtersSelectedText = [];
	$.each(filters, function(filterKey, filterIgnore)
	{
		if(typeof(scope[filterKey]) != 'undefined' && typeof(scope[filterKey].selected_value) != 'undefined' && scope[filterKey].selected_value != filterIgnore)
		{
			var currentFilterObj = {'label' : '', 'value' : ''};
			currentFilterObj.label = typeof(scope[filterKey].label) != 'undefined' ? scope[filterKey].label : '';
			currentFilterObj.value = typeof(scope[filterKey].select_options) != 'undefined' && typeof(scope[filterKey].select_options[scope[filterKey].selected_value]) != 'undefined' ? scope[filterKey].select_options[scope[filterKey].selected_value].label : '';
			
			if(currentFilterObj.label == '' || currentFilterObj.value == '')
			{
				return true;
			}	
			
			if(scope.filtersSelectedText.length > 0)
			{
				currentFilterObj.label = ', ' + currentFilterObj.label;
			}	
			
			scope.filtersSelectedText.push(currentFilterObj);
		}	
	});
}

function array_flip( trans )
{
    var key, tmp_ar = {};

    for ( key in trans )
    {
        if ( trans.hasOwnProperty( key ) )
        {
            tmp_ar[trans[key]] = key;
        }
    }

    return tmp_ar;
}

/**
 * @fullscreenWidget - Custom directive for fullscreen widgets
 */

function fullscreenWidgetCustom() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function(event) {
                
				// add a custom class to set the correct background color 
				$(this).parent().parent().parent().toggleClass('panel-default-expanded');
                
                setTimeout(function(){$(window).trigger('resize');}, 200);
            });
        }
    }
};

angular.module('potentiateApp').directive('fullscreenWidget', fullscreenWidgetCustom);